<template>
  <div>
    <div class="product-desc-content">
      <h3>Test e sondaggi</h3>

      <p v-if="resultSum > 0">Somma delle valutazioni ricevute: {{ resultSum }} </p>
      <p v-if="resultAvg > 0">Media delle valutazioni ricevute: {{ resultAvg }} </p>
      <button class="btn btn-outline-primary mb-3" data-toggle="modal" data-target="#modal-test">
        <i class="las la-plus mr-1"></i>Nuovo test
      </button>
      <div id="testcomponent">
        <div class="test-card bg-white rounded p-4 mb-3" v-for="test in tests" :key="test.id">
          <div class="test-card-header">
            <span class="test-type-icon" :class="'test-type-' + test.type_request">
              <i :class="testTypeIcon(test.type_request)"></i>
            </span>
            <div class="test-card-heading">
              <p class="test-question">{{ test.request }}</p>
              <span class="test-meta">{{ testTypeLabel(test.type_request) }} &middot; {{ test.created_at }}</span>
            </div>
          </div>

          <div class="test-tags"
            v-if="test.archive == 1 || !test.response_enable || (test.test_response != null && test.test_response.vote != null)">
            <span v-if="test.archive == 1" class="test-tag tag-dark"><i class="las la-archive"></i>Archiviato</span>
            <span v-if="!test.response_enable" class="test-tag tag-success"><i class="las la-check"></i>Hai
              risposto</span>
            <span v-if="test.test_response != null && test.test_response.vote != null" class="test-vote">
              <span>Voto ricevuto:</span>
              <span class="stars">
                <i v-for="star in 5" :key="star" class="las la-star"
                  :class="star <= test.test_response.vote ? 'star-filled' : 'star-empty'"></i>
              </span>
            </span>
          </div>

          <div v-if="
            test.type_request == 3 &&
            !test.is_property_test &&
            !test.response_enable
          " class="mt-3">
            <button type="button" class="btn btn-outline-primary btn-sm" @click="openChart(test.id)">
              <i class="las la-bar-chart mr-1"></i>Guarda i risultati
            </button>
          </div>

          <div v-if="!test.is_property_test">
            <div v-if="test.archive == 0 && test.response_enable" class="mt-3">
              <div v-if="test.type_request == 1">
                <textarea class="form-control" rows="2" maxlength="255" v-model="responses[test.id]"
                  placeholder="Inserisci la tua risposta"></textarea>
                <div class="text-right mt-2">
                  <button type="button" class="btn btn-primary" @click="sendResponse(test)">
                    Conferma la risposta
                  </button>
                </div>
              </div>
              <div v-if="test.type_request == 2 || test.type_request == 3">
                <div v-for="(response, key) in test.responses" :key="key">
                  <label v-if="response !== null" :for="'radio_' + test.id + '_' + key"
                    class="radio-option d-flex align-items-center w-100 mb-2 px-3 py-2 rounded border"
                    :class="responses[test.id] == key ? 'radio-option-selected' : ''">
                    <input type="radio" :name="'test_' + test.id" :id="'radio_' + test.id + '_' + key"
                      v-model="responses[test.id]" :value="key" class="mr-3 flex-shrink-0" />
                    {{ response }}
                  </label>
                </div>
                <textarea class="form-control mt-2" rows="2" maxlength="255" v-model="noteResponses[test.id]"
                  placeholder="Inserisci una nota alla risposta" v-if="test.type_request == 2"></textarea>
                <div class="text-right mt-2">
                  <button type="button" class="btn btn-primary" @click="sendResponse(test)">
                    Conferma la risposta
                  </button>
                </div>
              </div>
            </div>

            <div v-else-if="(test.type_request == 2 || test.type_request == 3) && test.test_response != null"
              class="mt-3 answer-summary">
              <div class="answer-summary-row">
                <span class="answer-summary-label">La tua risposta</span>
                <span class="answer-pill">
                  <i class="las la-check-circle mr-1"></i>{{ test.responses[test.test_response.response] }}
                </span>
                <button type="button" class="btn btn-link toggle-options" @click="toggleOptions(test.id)">
                  {{ showOptionsPanel[test.id] ? "Nascondi le opzioni" : "Vedi tutte le opzioni" }}
                  <i class="las" :class="showOptionsPanel[test.id] ? 'la-angle-up' : 'la-angle-down'"></i>
                </button>
              </div>
              <p v-if="test.test_response.note" class="answer-note">
                <i class="las la-sticky-note mr-1"></i>{{ test.test_response.note }}
              </p>
              <div v-if="showOptionsPanel[test.id]" class="options-list mt-2">
                <div v-for="(response, key) in test.responses" :key="key">
                  <div v-if="response !== null" class="option-row"
                    :class="test.test_response.response == response ? 'option-row-selected' : ''">
                    <i v-if="test.test_response.response == response" class="las la-check-circle"></i>
                    <i v-else class="las la-circle-o option-row-placeholder"></i>
                    {{ response }}
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="test.is_property_test == false && test.response_count > 0 && test.is_show_responses == true && test.response_enable == false"
              class="mt-3">
              <button type="button" class="btn btn-link toggle-options" @click="toggleResponses(test.id)">
                <i class="las la-users mr-1"></i>
                <span v-if="!showResponsesPanel[test.id]">Mostra le risposte degli altri utenti ({{
                  test.response_count }})</span>
                <span v-else>Nascondi le risposte degli altri utenti</span>
                <i class="las" :class="showResponsesPanel[test.id] ? 'la-angle-up' : 'la-angle-down'"></i>
              </button>
              <div v-if="showResponsesPanel[test.id]" class="other-responses mt-2">
                <p v-if="!allResponses[test.id]" class="text-muted mb-0">
                  Caricamento delle risposte in corso...
                </p>
                <p v-else-if="allResponses[test.id].length === 0" class="text-muted mb-0">
                  Nessuna risposta disponibile.
                </p>
                <ul v-else class="other-responses-list">
                  <li v-for="userResponse in allResponses[test.id]" :key="userResponse.id" class="other-response-item">
                    <span class="avatar-initials">{{ initials(userResponse.full_name) }}</span>
                    <div class="other-response-body">
                      <div class="other-response-meta">
                        <strong>{{ userResponse.full_name }}</strong>
                        <span class="other-response-date">{{ userResponse.created_at }}</span>
                      </div>
                      <p class="other-response-text">{{ userResponse.response }}</p>
                      <p v-if="userResponse.note" class="other-response-note">
                        <i class="las la-sticky-note mr-1"></i>{{ userResponse.note }}
                      </p>
                      <span class="stars" v-if="userResponse.vote != null">
                        <i v-for="star in 5" :key="star" class="las la-star"
                          :class="star <= userResponse.vote ? 'star-filled' : 'star-empty'"></i>
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div v-else class="creator-actions mt-3">
            <button v-if="test.archive == 0" type="button" class="btn btn-sm btn-dark" @click="archiveTest(test)">
              <i class="las la-archive mr-1"></i>Archivia il test
            </button>

            <router-link v-if="test.response_count > 0" :to="'/test/result/' + test.id"
              class="btn btn-sm btn-outline-primary">
              <i class="las la-list mr-1"></i>Analizza le risposte
            </router-link>

            <button v-if="test.type_request == 3" type="button" class="btn btn-sm btn-outline-primary"
              @click="openChart(test.id)">
              <i class="las la-bar-chart mr-1"></i>Guarda i risultati
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" id="modal-test"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl" style="max-width: 90%; max-height: 90%">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title justify-content-center">Nuovo test</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-test">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="sendTest">
            <div class="modal-body">
              <div class="m-4">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="domanda_test_intervista">Domanda</label>

                      <input type="text" class="form-control" id="domanda_test_intervista"
                        placeholder="Inserisci la tua nuova domanda" v-model="testRequest.request" />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="tipo_risposta_intervista">Che tipo di test vuoi effettatuare?</label>

                      <select @change="changeCountry($event)" class="form-control">
                        <option v-for="opt in typeTest" :key="opt.id" v-bind:value="opt.id">
                          {{ opt.value }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <hr />
                <div v-if="
                  testRequest.type_request == 3 ||
                  testRequest.type_request == 2
                ">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="risposta_1_intervista">Risposta 1 </label>
                        <input type="text" class="form-control" id="risposta_1_intervista"
                          v-model="testRequest.responses.response_1"
                          placeholder="Inserisci la risposta 1 da far selezionare" />
                        <div class="alert alert-danger" v-if="errors.responses && errors.responses.response_1">
                          {{ errors.responses.response_1[0] }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="risposta_2_intervista">Risposta 2</label>
                        <input type="text" class="form-control" id="risposta_2_intervista"
                          v-model="testRequest.responses.response_2"
                          placeholder="Inserisci la risposta 2 da far selezionare" />
                        <div class="alert alert-danger" v-if="errors.responses && errors.responses.response_2">
                          {{ errors.responses.response_2[0] }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="risposta_3_intervista">Risposta 3</label>
                        <input type="text" class="form-control" id="risposta_3_intervista"
                          v-model="testRequest.responses.response_3"
                          placeholder="Inserisci la risposta 1 da far selezionare" />
                        <div class="alert alert-danger" v-if="errors.responses && errors.responses.response_3">
                          {{ errors.responses.response_3[0] }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="risposta_4_intervista">Risposta 4</label>
                        <input type="text" class="form-control" id="risposta_4_intervista"
                          v-model="testRequest.responses.response_4"
                          placeholder="Inserisci la risposta 4 da far selezionare" />
                        <div class="alert alert-danger" v-if="errors.responses && errors.responses.response_4">
                          {{ errors.responses.response_4[0] }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="risposta_5_intervista">Risposta 5</label>
                        <input type="text" class="form-control" id="risposta_5_intervista"
                          v-model="testRequest.responses.response_5"
                          placeholder="Inserisci la risposta 5 da far selezionare" />
                        <div class="alert alert-danger" v-if="errors.responses && errors.responses.response_5">
                          {{ errors.responses.response_5[0] }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary">
                Pubblica il test
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- End .product-desc-content -->

    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" id="pie-chart-modal"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl" style="max-width: 90%; max-height: 90%">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Grafico</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <Bar v-if="loaded" :data="chartData" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
window.jQuery = $;
window.$ = $;
import httpauth from "@/services/httpauth.js";

import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);
export default {
  name: "TestComponent",
  props: ["activity_id_params"],
  components: { Bar },
  data() {
    return {
      tests: [],
      resultSum: 0,
      resultAvg: 0.00,
      testRequest: {
        activity_id: 0,
        request: "",
        type_request: 1,
        responses: {
          response_1: "",
          response_2: "",
          response_3: "",
          response_4: "",
          response_5: "",
        },
      },
      responses: [],
      noteResponses: [],
      allResponses: [],
      showResponsesPanel: {},
      showOptionsPanel: {},
      typeTest: [
        { id: 1, value: "Risposta aperta" },
        { id: 2, value: "Risposta multipla" },
        { id: 3, value: "Sondaggio di opinioni" },
      ],
      responseOptions: [
        { value: 1, text: "Seleziona la prima risposta" },
        { value: 2, text: "Seleziona la seconda risposta" },
        { value: 3, text: "Seleziona la terza risposta" },
        { value: 4, text: "Seleziona la quarta risposta" },
        { value: 5, text: "Seleziona la quinta risposta" },
      ],
      errors: [],
      cssClassCreateRequest: "",
      loaded: false,
      chartData: null,
    };
  },
  mounted() {
    $(document).on("show.bs.modal", ".modal", function () {
      $(this).appendTo("body");
    });
  },
  created() {

    this.loadTests(this.activity_id_params);
    this.showMyResponse(this.activity_id_params);
  },
  methods: {
    async loadTests(activity_id) {
      httpauth
        .get("/test/" + activity_id)
        .then(async (response) => {
          this.tests = response.data.data;
          for (var i = 0; i < this.tests.length; i++)
          {
            if (this.tests[i].response_count > 0)
            {
              if (this.tests[i].is_property_test == false)
              {
                await this.showResponseTest(this.tests[i].id);
              }
            }
          }
        }).catch((error) => {
          console.error(error);
        });
    },
    async showMyResponse(activityId) {
      return httpauth
        .get("/user/test-response/" + activityId).then(async (response) => {
          console.log("RISPOSTE");
          console.log(response.data.data);
          response.data.data;
          var count = 0;
          for (var i = 0; i < response.data.data.length; i++)
          {
            count++;
            this.resultSum = parseFloat(response.data.data[i].vote) + parseFloat(this.resultSum);
          }

          this.resultAvg = parseFloat(this.resultSum / count).toFixed(2);
        }).catch((error) => {

          console.error(error);
        });
    },
    async showResponseTest(testId) {
      console.log("/test-response/" + testId);
      return httpauth
        .get("/test-response/" + testId).then(async (response) => {
          this.allResponses[testId] = response.data.data;
        }).catch((error) => {
          this.allResponses[testId] = [];
          console.error(error);
        });
    },
    toggleResponses(testId) {
      this.showResponsesPanel[testId] = !this.showResponsesPanel[testId];
    },
    toggleOptions(testId) {
      this.showOptionsPanel[testId] = !this.showOptionsPanel[testId];
    },
    testTypeIcon(typeId) {
      const icons = { 1: "la-comment", 2: "la-list-ul", 3: "la-pie-chart" };
      return "las " + (icons[typeId] || "la-comment");
    },
    testTypeLabel(typeId) {
      const found = this.typeTest.find((t) => t.id == typeId);
      return found ? found.value : "";
    },
    initials(fullName) {
      if (!fullName) return "?";
      const parts = fullName.trim().split(/\s+/);
      const first = parts[0] ? parts[0][0] : "";
      const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
      return (first + last).toUpperCase();
    },
    openChart(id) {
      httpauth.get("/test-response/get-stats/" + id).then((response) => {
        this.chartData = {
          labels: response.data.data.label,
          datasets: [
            {
              label: "Data One",
              backgroundColor: "#f87979",
              data: response.data.data.value,
            },
          ],
        };

        this.loaded = true;

        $("#pie-chart-modal").modal("show");
      });
    },
    changeCountry(event) {
      this.testRequest.type_request = event.target.value;
    },
    async sendResponse(testRequest) {
      const response = {
        test_request_id: testRequest.id,
        response_note: this.noteResponses[testRequest.id],
        response: this.responses[testRequest.id],
      };

      await httpauth
        .post("/test-reponse/store", response)
        .then((response) => {
          const $toast = useToast();
          $toast.open({
            message: response.data.message,
            type: "info",
            position: "top-right",
            // all of other options may go here
          });
          for (var i = 0; i < this.tests.length; i++)
          {
            if (this.tests[i].id == testRequest.id)
            {
              this.tests[i].response_enable = false;
              break;
            }
          }
        })
        .catch((error) => {
          if (
            error.response.data.errors &&
            error.response.data.errors.response[0]
          )
          {
            const $toast = useToast();
            $toast.open({
              message: error.response.data.errors.response[0],
              type: "warning",
              position: "top-right",
              // all of other options may go here
            });
          }
        });
    },
    async sendTest() {
      this.testRequest.activity_id = this.activity_id_params;
      await httpauth
        .post("/test/store", this.testRequest)
        .then((response) => {
          $("#modal-test").modal("hide");
          document.getElementById("close-modal-test").click();
          this.testRequest.request = "";
          this.testRequest.type_request = 1;
          this.testRequest.responses.response_1 = "";
          this.testRequest.responses.response_2 = "";
          this.testRequest.responses.response_3 = "";
          this.testRequest.responses.response_4 = "";
          this.testRequest.responses.response_5 = "";
          const $toast = useToast();
          $toast.open({
            message: response.data.message,
            type: "info",
            position: "top-right",
            // all of other options may go here
          });
          this.loadTests(this.activity_id_params);
        })
        .catch((error) => {
          if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
        });
    },
    archiveTest(test) {
      const request = {
        id: test.id,
        archive: test.archive == 1 ? 0 : 1,
      };
      httpauth.post("/test/archive", request).then((response) => {
        const $toast = useToast();
        $toast.open({
          message: response.data.message,
          type: "info",
          position: "top-right",
          // all of other options may go here
        });
        for (var i = 0; i < this.tests.length; i++)
        {
          if (test.id == this.tests[i].id)
          {
            this.tests[i].archive = 1;
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.test-card {
  border: 1px solid #ebebeb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.test-card:hover {
  border-color: #e2c39c;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.07);
}

.test-card-header {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.test-type-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
}

.test-type-1 {
  background-color: #cc9966;
}

.test-type-2 {
  background-color: #333333;
}

.test-type-3 {
  background-color: #a6c76c;
}

.test-card-heading {
  flex: 1;
  min-width: 0;
}

.test-question {
  margin: 0;
  font-weight: 600;
  color: #222;
}

.test-meta {
  color: #999;
}

.test-tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-top: 1rem;
}

.test-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.9rem;
  border-radius: 30px;
  color: #fff;
  font-weight: 500;
}

.tag-dark {
  background-color: #333333;
}

.tag-success {
  background-color: #a6c76c;
}

.test-vote {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #777;
}

.stars i {
  margin-right: 1px;
}

.star-filled {
  color: #cc9966;
}

.star-empty {
  color: #e0e0e0;
}

.radio-option {
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
  user-select: none;
  border-color: #ebebeb !important;
}

.radio-option:hover {
  background-color: #faf6f1;
  border-color: #e2c39c !important;
}

.radio-option-selected {
  border-color: #cc9966 !important;
  background-color: #faf3ea !important;
  font-weight: 600;
}

.radio-option input[type="radio"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #cc9966;
}

.answer-summary-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.85rem;
}

.answer-summary-label {
  color: #999;
}

.answer-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 1.1rem;
  border-radius: 30px;
  background-color: #cc9966;
  color: #fff;
  font-weight: 600;
}

.toggle-options {
  color: #cc9966;
  text-decoration: none;
  padding: 0;
}

.toggle-options:hover,
.toggle-options:focus {
  color: #a37a4d;
  text-decoration: none;
}

.answer-note {
  margin: 0.6rem 0 0;
  font-style: italic;
  color: #888;
}

.options-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.option-row {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.55rem 0.9rem;
  border: 1px solid #ebebeb;
  border-radius: 6px;
  color: #777;
}

.option-row-selected {
  border-color: #cc9966;
  background-color: #faf3ea;
  color: #222;
  font-weight: 600;
}

.option-row-placeholder {
  color: #ccc;
}

.other-responses-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.other-response-item {
  display: flex;
  gap: 1rem;
  padding: 1.1rem 0;
  border-bottom: 1px solid #ebebeb;
}

.other-response-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.avatar-initials {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background-color: #a6c76c;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.other-response-body {
  flex: 1;
  min-width: 0;
}

.other-response-meta {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.other-response-date {
  color: #999;
}

.other-response-text {
  margin: 0.5rem 0 0;
  color: #333;
}

.other-response-note {
  margin: 0.5rem 0 0;
  font-style: italic;
  color: #888;
}

.creator-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.6rem;
}
</style>
